export const queryKeys = {
  accessToken: 'accessToken',
  locations: 'locations',
  categories: 'categories',
  loadPortal: 'loadPortal',
  assets: 'assets',
  equipmentInfo: 'equipmentInfo',
  equipmentRate: 'equipmentRate',
  portalInfo: 'portalInfo',
  bookingInfo: 'bookingInfo',
  agreement: 'agreement',
  partnerInfo: 'partnerInfo',
  locationHours: 'locationHours',
  promotion: 'promotion',
  partnerPhone: 'partnerPhone',
};
